<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="overview-wrap">
          <h2 class="title-1">Админ нууц үг солих</h2>
        </div>
      </div>
    </div>

    <div class="card w-100 mt-3">
      <div class="card-body">
        <div class="row form-group">
          <div class="col-3">
            <label class="form-control-label">Хуучин нууц үг</label>
          </div>
          <div class="col-9">
            <input
              class="au-input au-input--full"
              type="password"
              placeholder="Хуучин нууц үг"
              v-on:input="onChangeHandler('oldPassword', $v.oldPassword)"
              :class="{ 'form-control is-invalid': $v.oldPassword.$error }"
              v-model="oldPassword"
            >
            <div class="invalid-feedback">{{ this.getErrorMsg('oldPassword')[0] }}</div>
          </div>
        </div>
        <div class="row form-group">
          <div class="col-3">
            <label class="form-control-label">Шинэ нууц үг</label>
          </div>
          <div class="col-9">
            <input
              class="au-input au-input--full"
              type="password"
              placeholder="Шинэ нууц үг"
              v-on:input="onChangeHandler('newPassword', $v.newPassword)"
              :class="{ 'form-control is-invalid': $v.newPassword.$error }"
              v-model="newPassword"
            >
            <div class="invalid-feedback">{{ this.getErrorMsg('newPassword')[0] }}</div>
          </div>
        </div>
        <div class="row form-group">
          <div class="col-3">
            <label for="select" class="form-control-label">Шинэ нууц үг давтах</label>
          </div>
          <div class="col-9">
            <input
              class="au-input au-input--full"
              type="password"
              placeholder="Шинэ нууц үг давтах"
              v-on:input="onChangeHandler('newPasswordConfirm', $v.newPasswordConfirm)"
              :class="{ 'form-control is-invalid': $v.newPasswordConfirm.$error }"
              v-model="newPasswordConfirm"
            >
            <div class="invalid-feedback">{{ this.getErrorMsg('newPasswordConfirm')[0] }}</div>
          </div>
        </div>
      </div>
      <div class="card-footer d-flex justify-content-end">
        <button @click="onSubmit" class="btn btn-success">
          <i class="fa fa-dot-circle-o"></i> Хадгалах
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import AdminService from "@/services/AdminService.js";
import Form from "@/mixins/Form.js";

export default {
  name: "AdminEdit",

  mixins: [Form],

  data() {
    return {
      oldPassword: "",
      newPassword: "",
      newPasswordConfirm: ""
    };
  },

  created() {
    if (this.$store.getters.loggedAdmin.id != this.$route.params.id)
      this.$router.push("/admins");
  },

  validations: {
    oldPassword: {
      serverFailed: function() {
        return !this.hasServerError("oldPassword");
      }
    },
    newPassword: {
      serverFailed: function() {
        return !this.hasServerError("newPassword");
      }
    },
    newPasswordConfirm: {
      serverFailed: function() {
        return !this.hasServerError("newPasswordConfirm");
      }
    }
  },

  methods: {
    serverRequest: AdminService.changePassword,

    successHandler(response) {
      if (response.data.payload.toast !== null)
        this.showToast(response.data.payload.toast);

      this.$router.push("/admins");
    },

    createJsonData() {
      const data = JSON.parse("{}");
      data.id = this.$route.params.id;
      data.oldPassword = this.oldPassword;
      data.newPassword = this.newPassword;
      data.newPasswordConfirm = this.newPasswordConfirm;
      return data;
    }
  }
};
</script>
